import type { IFastLinkButtonVariantsData } from "@components/fastFields/fastLinkButton/types";
import {
  ILinkButtonSizeEnum,
  ILinkButtonVariantsEnum,
} from "@components/molecules/linkButton";
import { IAuthStepEnum } from "@/templates/authManagement/authStore";
import { routePath } from "@routes/path";

export const fastLinkButtonVariants: IFastLinkButtonVariantsData = {
  edit: {
    label: (t) => t("edit"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  loadMore: {
    label: (t) => t("loadMore"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
  },
  viewAll: {
    label: (t) => t("viewAll"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
  },
  forgetPassword: {
    label: (t) => t("page:auth.login.actions.forgetPassword"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Gray,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.RESET_PASSWORD?.toString(),
    }),
    hasUnderline: true,
  },
  return: {
    label: (t) => t("page:auth.header.actions.return"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.LOGIN?.toString(),
    }),
  },
  goToWebsite: {
    label: (t) => t("page:auth.header.actions.enterWebsite"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: "/",
  },
  resendCode: {
    label: (t) => t("page:auth.codeVerification.actions.resendCode"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Black,
    hasUnderline: true,
  },
  sendVerificationCode: {
    label: (t) => t("page:sendVerificationCode.sendCode"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  confirmEmail: {
    label: (t) => t("page:confirmEmail"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  signUp: {
    label: (t) => t("page:auth.signUp"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.SIGNUP?.toString(),
    }),
  },
  login: {
    label: (t) => t("page:studentProfileContainer.loginText"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.LOGIN?.toString(),
    }),
    startIcon: "LoginBoxLine",
  },
};
